import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

function useQueryParams(): { [key: string]: string | null } {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    const result: { [key: string]: string | null } = {};

    Array.from(params.entries()).forEach(([key, value]) => {
      result[key] = value;
    });

    return result;
  }, [search]);
}

export default useQueryParams;
